$(document).ready(function () {
  /**
   * Create charts if they exist.
   */
  $(function () {
    let e = $('.chart'); // get all instances of chart.

    // Loop through the charts.
    e.each(function () {
      let target = $(this).attr('id');
      let chart = $(this).data('chart');

      let data = JSON.parse($('#' + target + '-data').html());
      let options = JSON.parse($('#' + target + '-options').html());

      drawCharts(chart, target, data, options);
    });
  });
});

/**
 * Draw charts.
 *
 * @param chart
 * @param target
 * @param data
 * @param options
 * @return void
 */
const drawCharts = function (chart, target, data, options) {
  if (typeof window.google.charts !== 'undefined') {
    google.charts.load('current', {'packages': ['corechart']});

    if (chart === 'lineChart') {
      google.charts.setOnLoadCallback(function () {
        lineChart(target, data, options)
      });
    }
    if (chart === 'barChart') {
      google.charts.setOnLoadCallback(function () {
        barChart(target, data, options)
      });
    }
    if (chart === 'columnChart') {
      google.charts.setOnLoadCallback(function () {
        columnChart(target, data, options)
      });
    }
  } else {
    setTimeout(drawChars(chart, target, data, options), 1000);
  }
}

/**
 * Draw a line chart on target.
 *
 * @param target
 * @param data
 * @param options
 * @return void
 */
const lineChart = function (target, data, options) {
  let chartData = google.visualization.arrayToDataTable(data);
  let chartOptions = options;

  let chart = new google.visualization.LineChart(
    document.getElementById(target)
  );

  chart.draw(chartData, chartOptions);
}

/**
 * Draw a bar chart on target.
 *
 * @param target
 * @param data
 * @param options
 * @return void
 */
const barChart = function (target, data, options) {
  let chartData = google.visualization.arrayToDataTable(data);
  let chartOptions = options;

  let chart = new google.visualization.BarChart(
    document.getElementById(target)
  );

  chart.draw(chartData, chartOptions);
}

/**
 * Draw a column chart on target.
 *
 * @param target
 * @param data
 * @param options
 */
const columnChart = function (target, data, options) {
  let chartData = google.visualization.arrayToDataTable(data);
  let chartOptions = options;

  let chart = new google.visualization.ColumnChart(
    document.getElementById(target)
  );

  chart.draw(chartData, chartOptions);
}